<template lang="pug">
  .div
    .columns
      h3.title Último Folio en sistema
    .columns(v-show="verData")
      .column.is-6(v-for="f in folios")
        .notification
          .columns
            .column.is-6
              small Folio actual en {{ f.lugar}}:&nbsp
            .column.is-6
              strong {{ f.folioActual }}
    .columns(v-show="!verData")
      .notification
        span Obteniendo información ...
    .columns(v-show="verData")
      .column.is-6
        .field
          label.label Actualizar Folio de embarque
            .control.has-icons-left.has-icons-right
              input.input.is-black(
                type='text', 
                placeholder='Folio Actual...',
                v-model="folioActual",
                :disabled="isDisabled"
              )
    .columns(v-show="verData")
      a.button.is-black(@click="checkForm")
        | Guardar
    ModalFolio(v-show="modalStatus" :title="titleModal" :content="contentModal" @saveFolio="checkFolio")
</template>

<script>
  import ModalFolio from '../componentes/ModalFolio.vue'
  import sca_tuxpanServices from '@/services/sca/tpa.js' 

  export default {
    name: 'FormFolio',
    components: { ModalFolio },
    props: {
      folios: {
        type: Array,
        default: []
      }
    },
    data() {
      return {
        folioActual: null,
        datosFaltantes: [],
        isDisabled: false,
        titleModal: '',
        contentModal: '',
        modalStatus: false,
        verData: false
      }
    },
    watch: {
      folios() {
        this.checkData()
      }
    },
    methods: {
      iniciarComponente() {
        this.checkData()
      },
      checkData() {
        if (Object.keys(this.folios).length > 0) {
          this.verData = true
        } else {
          this.verData = false
        }
      },
      checkForm() {
        if (this.folioActual) {
          this.titleModal = 'Actualizar Folio de Embarque'
          this.contentModal = `¿Desea actualizar el valor del folio a ${this.folioActual}?`
          this.modalStatus = true
        } else {
          this.datosFaltantes.push('El folio de embarqure es requerido.')
        }
      },
      guardar() {
        console.log('Guardar')
        sca_tuxpanServices.updateControlId(this.folioActual)
          .then( resp => {
            console.log(resp)
            if (resp.success) {
              let toast = this.$toasted.show(`El valor del Folio ha sido Actualizado.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'done',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
              
            } else {
              let toast = this.$toasted.show(`Error: No se pudo actualizar el Folio de Embarque.`, { 
                theme: "toasted-primary", 
                position: "bottom-right", 
                duration : 3000,
                iconPack: 'fontawesome',
                icon: 'ban',
                action : {
                  text : 'Ok',
                  onClick : (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                },
              })
            }
          })
          .catch(e => console.log(e))
      },
      checkFolio (result) {
        if (result) {
          console.log('Guardar')          
          this.guardar()
        } else {
          console.log('No hacer nada')
        }
        this.titleModal = ''
        this.contentModal = ''
        this.modalStatus = false

      }
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/FormFolio.vue